<template>
  <div class="c-search-price">
    <div class="c-search-price-row">
      <h2>Cena katalogowa brutto (PLN)</h2>
    </div>
    <div class="c-search-price-row">
      <div class="c-search-price-range">
        <div ref="slider" class="c-search-price-range-slider">
        </div>
      </div>
    </div>

    {{Price.min}}
    {{Price.max}}

  </div>
</template>
<script>
import noUiSlider from 'nouislider'
import wNumb from 'wnumb'

export default {
  name: 'SearchPrice',
  props: [
    'Price'
  ],
  data () {
    return {
      Range: {
        from: 200000,
        to: 800000
      },
      step: 10000,
      Slider: document.getElementById('js-price-ranvge'),
      priceSlider: Object
    }
  },
  mounted: function () {
    var _this = this
    this.priceSlider = noUiSlider.create(this.$refs.slider, {
      start: [_this.Price.from.value, _this.Price.to.value],
      connect: true,
      behaviour: 'drag',
      step: 1,
      tooltips: [wNumb({ decimals: 0, prefix: 'od ', suffix: ' PLN', thousand: ' ' }), wNumb({ decimals: 0, prefix: 'do ', suffix: ' PLN', thousand: ' ' })],
      range: {
        'min': 20000,
        'max': 1000000
      }

    })
    this.priceSlider.on('change', function (values, handle) {
      _this.Price.from.value = parseInt(values[0])
      _this.Price.to.value = parseInt(values[1])

      var formatPrice = wNumb({ decimals: 0, prefix: 'od ', suffix: ' PLN', thousand: ' ' })
      _this.Price.from.name = formatPrice.to(parseInt(values[0]))

      var formatPrice = wNumb({ decimals: 0, prefix: 'do ', suffix: ' PLN', thousand: ' ' })
      _this.Price.to.name = formatPrice.to(parseInt(values[1]))

      _this.Price.from.selected = true
      _this.Price.to.selected = true
      // console.log(_this.Price);
      _this.$emit('Price', _this.Price)
    })
  }
}

</script>

<style lang="scss">
  .c-search-price{
    margin: 0 auto;
    max-width: 1177.6px;
    width: 92%;
    padding-bottom: 3rem;
    &-row{
      padding: 4rem 0;
    }
    .c-search-price-range{
      max-width: 1177.6px;
      width: 88%;
      margin: 0 auto;
      &-slider{
        width: 100%;
        position: relative;
      }
    }
  }

  /*! nouislider - 12.1.0 - 10/25/2018 */
  /* Functional styling;
   * These styles are required for noUiSlider to function.
   * You don't need to change these rules to apply your design.
   */
  .noUi-target,
  .noUi-target * {
    -webkit-touch-callout: none;
    // -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-user-select: none;
    -ms-touch-action: none;
    touch-action: none;
    -ms-user-select: none;
    -moz-user-select: none;
    user-select: none;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    &:focus{
      outline: none;
    }
  }
  .noUi-target {
    position: relative;
    direction: ltr;
  }
  .noUi-base,
  .noUi-connects {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
  }
  /* Wrapper for all connect elements.
   */
  .noUi-connects {
    overflow: hidden;
    z-index: 0;
  }
  .noUi-connect,
  .noUi-origin {
    will-change: transform;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    -ms-transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    &:last-of-type{
      .noUi-handle{
        .noUi-tooltip{
          top: 0px;
        }
      }
    }
  }
  /* Offset direction
   */
  html:not([dir="rtl"]) .noUi-horizontal .noUi-origin {
    left: auto;
    right: 0;
  }
  /* Give origins 0 height/width so they don't interfere with clicking the
   * connect elements.
   */
  .noUi-vertical .noUi-origin {
    width: 0;
  }
  .noUi-horizontal .noUi-origin {
    height: 0;
  }
  .noUi-handle {
    position: absolute;
  }
  .noUi-state-tap .noUi-connect,
  .noUi-state-tap .noUi-origin {
    -webkit-transition: transform 0.3s;
    transition: transform 0.3s;
  }
  .noUi-state-drag * {
    cursor: inherit !important;
  }
  /* Slider size and handle placement;
   */
  .noUi-horizontal {
    height: 18px;
  }
  .noUi-horizontal .noUi-handle {
    width: 34px;
    height: 28px;
    left: -17px;
    top: -6px;
  }
  .noUi-vertical {
    width: 18px;
  }
  .noUi-vertical .noUi-handle {
    width: 28px;
    height: 34px;
    left: -6px;
    top: -17px;
  }
  html:not([dir="rtl"]) .noUi-horizontal .noUi-handle {
    right: -17px;
    left: auto;
  }
  /* Styling;
   * Giving the connect element a border radius causes issues with using transform: scale
   */
  .noUi-target {
    background: #FAFAFA;
    border-radius: 4px;
    border: 1px solid #D3D3D3;
    box-shadow: inset 0 1px 1px #F0F0F0, 0 3px 6px -5px #BBB;
  }
  .noUi-connects {
    border-radius: 3px;
  }
  .noUi-connect {
    background: #3FB8AF;
  }
  /* Handles and cursors;
   */
  .noUi-draggable {
    cursor: ew-resize;
  }
  .noUi-vertical .noUi-draggable {
    cursor: ns-resize;
  }
  .noUi-handle {
    border: 1px solid #D9D9D9;
    border-radius: 3px;
    background: #FFF;
    cursor: default;
    box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
  }
  .noUi-active {
    box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
  }
  /* Handle stripes;
   */
  .noUi-handle:before,
  .noUi-handle:after {
    content: "";
    display: block;
    position: absolute;
    height: 14px;
    width: 1px;
    background: #E8E7E6;
    left: 14px;
    top: 6px;
  }
  .noUi-handle:after {
    left: 17px;
  }
  .noUi-vertical .noUi-handle:before,
  .noUi-vertical .noUi-handle:after {
    width: 14px;
    height: 1px;
    left: 6px;
    top: 14px;
  }
  .noUi-vertical .noUi-handle:after {
    top: 17px;
  }
  /* Disabled state;
   */
  [disabled] .noUi-connect {
    background: #B8B8B8;
  }
  [disabled].noUi-target,
  [disabled].noUi-handle,
  [disabled] .noUi-handle {
    cursor: not-allowed;
  }
  /* Base;
   *
   */
  .noUi-pips,
  .noUi-pips * {
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .noUi-pips {
    position: absolute;
    color: #999;
  }
  /* Values;
   *
   */
  .noUi-value {
    position: absolute;
    white-space: nowrap;
    text-align: center;
  }
  .noUi-value-sub {
    color: #ccc;
    font-size: 10px;
  }
  /* Markings;
   *
   */
  .noUi-marker {
    position: absolute;
    background: #CCC;
  }
  .noUi-marker-sub {
    background: #AAA;
  }
  .noUi-marker-large {
    background: #AAA;
  }
  /* Horizontal layout;
   *
   */
  .noUi-pips-horizontal {
    padding: 10px 0;
    height: 80px;
    top: 100%;
    left: 0;
    width: 100%;
  }
  .noUi-value-horizontal {
    -webkit-transform: translate(-50%, 50%);
    transform: translate(-50%, 50%);
  }
  .noUi-rtl .noUi-value-horizontal {
    -webkit-transform: translate(50%, 50%);
    transform: translate(50%, 50%);
  }
  .noUi-marker-horizontal.noUi-marker {
    margin-left: -1px;
    width: 2px;
    height: 5px;
  }
  .noUi-marker-horizontal.noUi-marker-sub {
    height: 10px;
  }
  .noUi-marker-horizontal.noUi-marker-large {
    height: 15px;
  }
  /* Vertical layout;
   *
   */
  .noUi-pips-vertical {
    padding: 0 10px;
    height: 100%;
    top: 0;
    left: 100%;
  }
  .noUi-value-vertical {
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%, 0);
    padding-left: 25px;
  }
  .noUi-rtl .noUi-value-vertical {
    -webkit-transform: translate(0, 50%);
    transform: translate(0, 50%);
  }
  .noUi-marker-vertical.noUi-marker {
    width: 5px;
    height: 2px;
    margin-top: -1px;
  }
  .noUi-marker-vertical.noUi-marker-sub {
    width: 10px;
  }
  .noUi-marker-vertical.noUi-marker-large {
    width: 15px;
  }
  .noUi-tooltip {
    display: block;
    position: absolute;
    border: 1px solid #D9D9D9;
    border-radius: 3px;
    background: #fff;
    color: #000;
    padding: 5px;
    text-align: center;
    white-space: nowrap;
  }
  .noUi-horizontal .noUi-tooltip {
    -webkit-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    left: 50%;
    bottom: 120%;
    font-weight: bold;
  }
  .noUi-vertical .noUi-tooltip {
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    top: 50%;
    right: 120%;
  }

  .noUi-horizontal .noUi-handle{
    background: #d5d9d8;
    border-radius: 50px;
    box-shadow: 2px 2px 5px rgba(0,0,0,.1);
    border: none;
    height: 40px;
    width: 40px;
    // position: relative;
    top: -18px;
    &:before {
      background: url('../assets/images/range.jpg');
      background-repeat: no-repeat;
      background-size: 60%;
      content: " ";
      display: block;
      height: 40px;
      top: 9px;
      left: 9px;
      position: absolute;
      width: 40px;
      z-index: 9999;
    }
  }
  .noUi-tooltip{
    padding-top: 50px;
  }
  .noUi-connects{
      width: 100%;
  }
  .noUi-connect{
    background: #c03;
  }
  .noUi-base,.noUi-target{
    height: 4px;
    background-color: #d5d9d8;
    border-radius: 2px;
    border: none;
  }
  .noUi-horizontal .noUi-tooltip{
    border: 0;
    background-color: transparent;
  }

</style>
